import React, { useContext, useEffect, useRef, useState } from 'react'
import Footer from '@/custom/components/molecules/Footer'
import { Link } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { useGoogleLogin, GoogleLogin } from '@react-oauth/google'
import './authLayout.css'
import Button from '@material-ui/core/Button'

import { LOGO, SITE_NAME } from '@/utils'
import { Dialog, Tooltip } from '@material-ui/core'
import Login from '@/views/Login/login'
import Registration from '@/views/Registration'
import SignContext from '@/custom/context/signContext'
import { mapData } from '@/product/common/components'

const AuthLayout = (props) => {
    const matches = useMediaQuery('(min-width:1025px)')
    const { handleLoginPopup, handleRegisterPopup, loginPopup } = useContext(SignContext)

    const processSocialLogin = (email, token) => {
        props.formik.values.email = email
        props.formik.values.google_id = token
        props.login(props.formik.values)
    }

    const responseGoogle = async (response) => {
        const token = response?.access_token || response?.credential
        console.log('google', response)
        if (response?.access_token) {
            try {
                const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })

                const userInfo = await response.json()
                if (userInfo?.email) {
                    processSocialLogin(userInfo?.email, token)
                }
            } catch (error) {
                console.error('Failed to fetch user info - google login', error)
            }
        } else {
            try {
                const userInfo = jwtDecode(response?.credential)
                if (userInfo?.email) {
                    processSocialLogin(userInfo?.email, userInfo.jti)
                }
            } catch (error) {
                console.error('Failed to fetch user info - google login', error)
            }
        }

        // const userDetails = jwtDecode(response.access_token)
        // console.log('Google Login Response Inside ', response, userDetails)
        // props.formik.values.email = userDetails.email
        // props.formik.values.google_id = userDetails.jti
        // props.login(props.formik.values)
    }

    const responseFacebook = async (response) => {
        if (response?.email) {
            processSocialLogin(response?.email, response.accessToken)
        }
    }

    const rememberMe = {
        formik: props.formik,
        data: [
            {
                label: 'Stay Signed In',
                name: 'remember_me',
                type: 'checkbox',
                placeholder: 'remember_me',
                class: '',
            },
        ],
    }

    const googleLogin = useGoogleLogin({
        onSuccess: (credentialResponse) => {
            console.log('google login', credentialResponse)
            responseGoogle(credentialResponse)
        },
        onError: (e) => {
            console.error('Google Login Response ERROR', e)
        },
    })
    return (
        <section className={props.className ? props.className : 'auth-wrapper'}>
            <div className="auth-header">
                <Link to="/" className="auth-logo" id="auth-logo">
                    <img src={LOGO} alt={SITE_NAME} style={{ width: '190px' }} />
                </Link>
            </div>
            <div className={props.formClass ? props.formClass : 'auth-container minHeht'}>
                {props.title ? (
                    <div className="auth-top">
                        <h2 className="auth-head-title">{props.title}</h2>
                        {props.login && (
                            <p className="auth-type my-2 text-center">Please Login to Continue</p>
                        )}
                        {/* {props.externalLink ? (
                            <p className="auth-note">
                                {props.authNote}{' '}
                                <a
                                    href={process.env.REACT_APP_ADMIN_DOMAIN}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Login here
                                </a>
                            </p>
                        ) : (
                            <p className="auth-note">
                                {props.authNote} <Link to={props.authLink}>{props.authText}</Link>
                            </p>
                        )} */}
                    </div>
                ) : (
                    <></>
                )}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    className="auth-form-wrapper"
                >
                    {/* {props.googleLogin || props.facebookLogin ? (
                        <b className="text-center d-block my-4">- OR -</b>
                    ) : null} */}
                    {props.children}
                    {props.externalLink ? (
                        <p className="auth-note">
                            {props.authNote}{' '}
                            <Link
                                // href={process.env.REACT_APP_ADMIN_DOMAIN}
                                to="#"
                                onClick={handleRegisterPopup}
                            >
                                Login here
                            </Link>
                        </p>
                    ) : (
                        <p className="auth-note">
                            {props.authNote}{' '}
                            <Link
                                to="#"
                                onClick={props.login ? handleRegisterPopup : handleLoginPopup}
                            >
                                {props.authText}
                            </Link>
                        </p>
                    )}
                    {props.login && (
                        <>
                            <hr className="loginLine" />
                            <div className="googleSignUp mb-4">
                                {props.googleLogin ? (
                                    <div className="googleBtn" onClick={() => googleLogin()}>
                                        <div className="customGoogleAuth">Continue with google</div>
                                        <img src="/assets/svg/googleImage.svg" />
                                        <div
                                            className="googleOldBtn"
                                            //  ref={googleButtonRef}
                                        >
                                            <GoogleLogin
                                                className="googleSignupBtn"
                                                onSuccess={(credentialResponse) => {
                                                    responseGoogle(credentialResponse)
                                                }}
                                                onError={() => {
                                                    console.log('Login Failed')
                                                }}
                                                text="signin_with"
                                                width="96%"
                                                size="large"
                                            />
                                        </div>
                                    </div>
                                ) : null}
                                {props.facebookLogin ? (
                                    <FacebookLogin
                                        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                                        fields="name,email"
                                        callback={responseFacebook}
                                        isMobile={false}
                                        disableMobileRedirect={true}
                                        render={(renderProps) => (
                                            <Button
                                                variant="outlined"
                                                onClick={renderProps.onClick}
                                                className="fbSignup"
                                                color="default"
                                            >
                                                <span>Continue with Facebook</span>
                                                <object
                                                    aria-label="Facebook Signin"
                                                    data="/assets/svg/facebook.svg"
                                                    type="image/svg+xml"
                                                ></object>
                                            </Button>
                                        )}
                                    />
                                ) : null}
                            </div>
                            {/* <div className="rememberMe buyProd">
                                {props.rememberMe ? Object.values(mapData(rememberMe)) : ''}
                                <Tooltip
                                    title="Stay Signed In allows you to remain logged into your account on this device even after closing your browser. This is useful for quick access but not recommended on shared or public devices for security reasons."
                                    placement="top-start"
                                    className="infoImage"
                                    arrow
                                >
                                    <img className="infoIcon" src="/assets/svg/infoIcon.svg" />
                                </Tooltip>
                            </div> */}
                        </>
                    )}
                </div>
                {props.title ? (
                    <>
                        {/* <div className="auth-divider">
                            <span>{props.seperatorText}</span>
                        </div> */}

                        {/* <ul className="auth-social">
                            <li>
                                <div>Google</div>
                                <div>
                                    <a>
                                        <img src="/assets/svg/google.svg" alt="Google" />
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>Facebook</div>
                                <div>
                                    <a>
                                        <img src="/assets/svg/fb.svg" alt="Facebook" />
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>Apple</div>
                                <div>
                                    <a>
                                        <img src="/assets/svg/apple.svg" alt="Apple" />
                                    </a>
                                </div>
                            </li>
                        </ul> */}
                    </>
                ) : (
                    <></>
                )}
            </div>
            {matches ? <Footer /> : <></>}
        </section>
    )
}

export default AuthLayout
